import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Button from './_button.js'
import Text from './_text.js'

export default {
  name: 'RecentSearch',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 0 16px',
          _mobile_padding: '0 16px 0 56px',
          minWidth: 0,
        },
      },
    },
    item: {
      configSet: FlexPane,
      configValues: {
        style: {
          _desktop_width: '380px',
          flexDirection: 'row',
          alignItems: 'center',
          minHeight: '40px',
        },
      },
    },
    itemIcon: {
      configSet: Image,
      configValues: {
        src: 'clock',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
    searchButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            overflow: 'hidden',
            padding: '0 8px',
          },
        },
      },
    },
    itemText: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    removeButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '40px',
            flexGrow: 0,
          },
        },
      },
    },
    removeIcon: {
      configSet: Image,
      configValues: {
        src: 'close',
        style: {
          minWidth: '8px',
          minHeight: '8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
